'use strict';

export function init() {
    const bookTicketsPopup = document.getElementById('book-tickets-popup');

    if (!bookTicketsPopup) return;

    const setMobileStickyHeight = () => {
        const mobileSticky = bookTicketsPopup.querySelector('.event-header__mobile-sticky');
        const mobileStickyHeight = mobileSticky ? mobileSticky.offsetHeight : 0;

        document.documentElement.style.setProperty(
            '--event-mobile-sticky-height', `${mobileStickyHeight}px`
        );
    };

    // Use a ResizeObserver to detect changes in the size of .event-header__mobile-sticky
    if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
            if (bookTicketsPopup.open) {
                setMobileStickyHeight();
            }
        });

        // Observe the popup itself
        resizeObserver.observe(bookTicketsPopup);
    }

    // Use MutationObserver to detect when dialog opens
    const dialogObserver = new MutationObserver(() => {
        if (bookTicketsPopup.open) {
            // Wait for dialog to render before calculating height
            setTimeout(() => {
                setMobileStickyHeight();
            }, 100);
        }
    });

    dialogObserver.observe(bookTicketsPopup, {
        attributes: true,
        attributeFilter: ['open']
    });

    setMobileStickyHeight();
    window.addEventListener('resize', setMobileStickyHeight);
}
